import { StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import React, { FC, useState } from 'react';
import { STYLE_VARS } from '../../../constants/style-vars';
import { Image } from '../../../components/Image';
import { useIsDesktop } from '../../../hooks/useIsDeskTop';
import { IS_WEB } from '../../../constants/platform';
import { addBase64Prefix } from '../../../services/addBase64Prefix';
import { close_icon } from '../../../assets/base64';
import { FONTS } from '../../../constants';

interface WeekDaySelectProps {
  setSelectedDay: React.Dispatch<React.SetStateAction<string[]>>;
  selectedDay: string[];
}

type OptionItem = {
  label: string;
  value: string;
};

const WeekDaySelect: FC<WeekDaySelectProps> = ({
  selectedDay,
  setSelectedDay,
}) => {
  const isDesktop = useIsDesktop();
  const handleDaySelect = (date: string) => {
    if (selectedDay.includes(date)) {
      const arr = selectedDay.filter((day) => day !== date);
      setSelectedDay(arr);
    } else {
      setSelectedDay([...selectedDay, date]);
    }
  };
  const styles = StyleSheet.create({
    title: {
      color: STYLE_VARS.textColor,
      fontSize: 13,
      fontFamily: FONTS.IowanOldStyleBTRoman,
      fontWeight: '500',
      textTransform: 'uppercase',
      marginBottom: 10,
    },
    selectWrapper: {
      width: isDesktop() ? '20%' : '30%',
      flexDirection: 'row',
      alignItems: 'center',
    },
    selectedText: {
      fontSize: 14,
      fontFamily: FONTS.IowanOldStyleBTRoman,
      color: STYLE_VARS.fccDarkerGrey,
      fontWeight: '500',
    },
  });

  const daysOfWeek: OptionItem[] = [
    {
      label: 'MONDAY',
      value: 'Monday',
    },
    {
      label: 'TUESDAY',
      value: 'Tuesday',
    },
    {
      label: 'WEDNESDAY',
      value: 'Wednesday',
    },
    {
      label: 'THURSDAY',
      value: 'Thursday',
    },
    {
      label: 'FRIDAY',
      value: 'Friday',
    },
    {
      label: 'SATURDAY',
      value: 'Saturday',
    },
    {
      label: 'SUNDAY',
      value: 'Sunday',
    },
  ];

  return (
    <View style={{ marginBottom: 30 }}>
      <Text style={styles.title}>Select preferred day of the week</Text>
      <View
        style={{
          flexWrap: 'wrap',
          rowGap: 15,
          flexDirection: 'row',
          justifyContent: isDesktop() ? 'flex-start' : 'space-between',
        }}
      >
        {daysOfWeek.map((day) => (
          <TouchableOpacity
            style={[styles.selectWrapper, { alignSelf: 'flex-start' }]}
            onPress={() => handleDaySelect(day.value)}
            key={day.value}
          >
            <View
              style={{
                width: 15,
                height: 15,
                borderWidth: 0.5,
                borderColor: STYLE_VARS.fccDarkGrey,
                borderRadius: 2,
                marginRight: 5,
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              {selectedDay.includes(day.value) && (
                <Image
                  source={
                    IS_WEB
                      ? addBase64Prefix(close_icon)
                      : require('../../../assets/close-icon.png')
                  }
                  style={{
                    width: 12,
                    height: 12,
                    tintColor: STYLE_VARS.fccDarkerGrey,
                  }}
                />
              )}
            </View>
            <Text style={styles.selectedText}>{day.label}</Text>
          </TouchableOpacity>
        ))}
      </View>
    </View>
  );
};

export default WeekDaySelect;
